






































import { Component, Prop, Mixins } from "vue-property-decorator";
import TemplateForm from "@/components/app/admin/notifications/templates/form.vue";
import RequestPromises from "@/mixins/requestPromises";
import {
  INotificationHook,
  INotificationTemplate,
  INotificationCategory
} from "@/models/notifications";

@Component({
  components: {
    TemplateForm,
    "action-contents-table": () =>
      import("@/components/app/admin/automation/actionContentsTable.vue")
  }
})
export default class ActionForm extends Mixins(RequestPromises) {
  @Prop({ default: "" })
  public notificationTemplateId!: INotificationTemplate["id"];

  @Prop({ default: () => ({}) })
  public returnTo!: any;

  @Prop({ default: null })
  public channelCode!: string;

  @Prop({ default: undefined })
  public categoryId!: INotificationCategory["id"];

  @Prop({ default: undefined })
  public hookId!: INotificationHook["id"];

  public templateSaved() {
    if (this.$_.isEmpty(this.returnTo)) {
      return;
    }
    return this.$router.push(this.returnTo);
  }
}
